import styled from 'styled-components';

export const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;

  svg {
    width: 22px;
    height: 22px;
    color: ${({ theme }) => theme.colors.element.primary};
    transition: opacity 0.2s ease-in;
  }

  &:hover svg {
    opacity: 0.8;
  }
`;
